import React from 'react';

import UnlinkModal from './unlink_modal';
import DemoGuardedButton from '../../shared/demoGuardedButton';

import AuthGoogleAccessForm from '../AuthGoogleAccessForm';
import { EXTRA_SMALL_ICON_BASE_SRC } from '../../../../Shared';

const linkedIcon = <img alt="green checkmark" className="linked-icon" src={`${EXTRA_SMALL_ICON_BASE_SRC}/check-color.svg`} />

const NYCPS_MANAGED_COPY = 'Your Quill sign-in is managed by NYC Public Schools, so other accounts cannot be linked.'

export default class TeacherLinkedAccounts extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showGoogleModal: false,
      showCleverModal: false,
      showClasslinkModal: false,
    }
  }

  componentDidUpdate(prevProps) {
    const { cleverId, googleId, classlinkId, nycpsId } = this.props
    if (prevProps.cleverId !== cleverId || prevProps.googleId !== googleId || prevProps.classlinkId !== classlinkId || prevProps.nycpsId !== nycpsId) {
      this.setState({
        showGoogleModal: false,
        showCleverModal: false,
        showClasslinkModal: false,
      })
    }
  }

  handleClickUnlinkClasslink = () => {
    this.setState({ showClasslinkModal: true, })
  }

  handleClickUnlinkClever = () => {
    this.setState({ showCleverModal: true, })
  }

  handleClickUnlinkGoogle = () => {
    this.setState({ showGoogleModal: true, })
  }

  hideClasslinkModal = () => {
    this.setState({ showClasslinkModal: false, })
  }

  hideCleverModal = () => {
    this.setState({ showCleverModal: false, })
  }

  hideGoogleModal = () => {
    this.setState({ showGoogleModal: false, })
  }

  isLinkedToClever = () => {
    const { cleverId } = this.props
    return cleverId && cleverId.length
  }

  isLinkedToGoogle = () => {
    const { googleId } = this.props
    return googleId && googleId.length
  }

  isLinkedToClasslink = () => {
    const { classlinkId } = this.props
    return classlinkId && classlinkId.length
  }

  isLinkedToNycps = () => {
    const { nycpsId } = this.props
    return nycpsId && nycpsId.length
  }

  isLinkedToAnyProvider = () => {
    return this.isLinkedToClever() || this.isLinkedToGoogle() || this.isLinkedToClasslink() || this.isLinkedToNycps()
  }

  handleClickLinkClever = () => {
    const { cleverLink } = this.props
    window.location.href = cleverLink
  }

  handleClickLinkClasslink = () => {
    window.location.href = 'https://launchpad.classlink.com/'
  }

  renderCleverSection = () => {
    let unlinkCopy
    let copy = 'Clever is not linked.'
    let className = 'unlinked'
    let actionElement = (
      <DemoGuardedButton
        ariaLabel="Link your Clever account"
        className='quill-button outlined green small provider-action focus-on-light disabled'
        disabled={true}
        onClick={this.handleClickLinkClever}
      >
        Link your account
      </DemoGuardedButton>
    )

    if (this.isLinkedToNycps()) {
      unlinkCopy = NYCPS_MANAGED_COPY
    }
    else if (this.isLinkedToClasslink()) {
      unlinkCopy = 'Unlink ClassLink to link your Clever account.'
    }
    else if (this.isLinkedToGoogle() && !this.isLinkedToClever()) {
      unlinkCopy = 'Unlink Google to link your Clever account.'
    } else if (!this.isLinkedToClever()) {
      copy = 'Clever is not linked.'
      actionElement = (
        <DemoGuardedButton
          ariaLabel="Link your Clever account"
          className='quill-button outlined green small provider-action focus-on-light'
          onClick={this.handleClickLinkClever}
        >
          Link your account
        </DemoGuardedButton>
      )
    } else {
      copy = 'Clever account is linked'
      className = 'linked'
      actionElement = (
        <button
          className='quill-button outlined red small provider-action focus-on-light'
          onClick={this.handleClickUnlinkClever}
          type='button'
        >
          Unlink
        </button>
      )
    }
    return (
      <React.Fragment>
        <div className='clever-row'>
          <div className={`first-half ${className}`}>
            <div>
              <img alt='Clever icon' src={`${window.postbuildEnv.CDN_URL}/images/shared/clever_icon.svg`} />
              <span>{copy}</span>
            </div>
            {this.isLinkedToClever() && linkedIcon}
          </div>
          {actionElement}
        </div>
        {unlinkCopy && <p className='unlink-copy'>{unlinkCopy}</p>}
      </React.Fragment>
    )
  }

  renderClasslinkSection = () => {
    let unlinkCopy
    let copy = 'ClassLink is not linked.'
    let className = 'unlinked'
    let actionElement = (
      <DemoGuardedButton
        ariaLabel="Link your ClassLink account"
        className='quill-button outlined green small provider-action focus-on-light disabled'
        disabled={true}
        onClick={this.handleClickLinkClasslink}
      >
        Link your account
      </DemoGuardedButton>
    )

    if (this.isLinkedToClasslink()) {
      copy = 'ClassLink is linked'
      className = 'linked'
      actionElement = (
        <button
          className='quill-button outlined red small provider-action focus-on-light'
          onClick={this.handleClickUnlinkClasslink}
          type='button'
        >
          Unlink
        </button>
      )
    }
    else if (!this.isLinkedToAnyProvider()) {
      actionElement = (
        <DemoGuardedButton
          ariaLabel="Link your ClassLink account"
          className='quill-button outlined green small provider-action focus-on-light'
          onClick={this.handleClickLinkClasslink}
        >
          Link your account
        </DemoGuardedButton>
      )
    }
    else if (this.isLinkedToNycps()) {
      unlinkCopy = NYCPS_MANAGED_COPY
    }
    else if (this.isLinkedToGoogle()) {
      unlinkCopy = `Unlink Google to link your ClassLink account.`
    }
    else if (this.isLinkedToClever()) {
      unlinkCopy = `Unlink Clever to link your ClassLink account.`
    }

    return (
      <React.Fragment>
        <div className='classlink-row'>
          <div className={`first-half ${className}`}>
            <div>
              <img alt='Classlink icon' className="classlink-icon" src={`${window.postbuildEnv.CDN_URL}/images/shared/classlink_icon_sm.png`} />
              <span>{copy}</span>
            </div>
            {this.isLinkedToClasslink() && linkedIcon}
          </div>
          {actionElement}
        </div>
        {unlinkCopy && <p className='unlink-copy'>{unlinkCopy}</p>}
      </React.Fragment>
    )
  }

  renderNycpsSection = () => {
    if (!this.isLinkedToNycps()) { return null }

    return (
      <React.Fragment>
        <div className='divider-line' />
        <div className='nycps-row'>
          <div className='first-half linked'>
            <div>
              <span>NYC Public Schools account is linked</span>
            </div>
            {linkedIcon}
          </div>
        </div>
      </React.Fragment>
    )
  }

  renderGoogleSection = () => {
    let unlinkCopy
    let copy = 'Google is not linked.'
    let className = 'unlinked'
    let actionElement = (
      <DemoGuardedButton
        ariaLabel="Link your Google account"
        className='quill-button outlined green small provider-action focus-on-light disabled'
        disabled={true}
        onClick={this.handleClickLinkGoogle}
      >
        Link your account
      </DemoGuardedButton>
    )

    if (this.isLinkedToNycps()) {
      unlinkCopy = NYCPS_MANAGED_COPY
    }
    else if (this.isLinkedToClasslink()) {
      unlinkCopy = 'Unlink ClassLink to link your Google account.'
    }
    else if (this.isLinkedToClever() && !this.isLinkedToGoogle()) {
      unlinkCopy = 'Unlink ClassLink to link your Google account.'
    } else if (!this.isLinkedToGoogle()) {
      actionElement = (
        <AuthGoogleAccessForm
          buttonClass='quill-button outlined green small focus-on-light'
          offlineAccess={true}
          showIcon={false}
          spanClass='provider-action'
          text='Link your account'
        />
      )
    } else {
      copy = 'Google account is linked'
      className = 'linked'
      actionElement = (
        <button
          className='quill-button outlined red small provider-action focus-on-light'
          onClick={this.handleClickUnlinkGoogle}
          type='button'
        >
          Unlink
        </button>
      )
    }
    return (
      <React.Fragment>
        <div className='google-row'>
          <div className={`first-half ${className}`}>
            <div>
              <img alt='Google icon' src={`${window.postbuildEnv.CDN_URL}/images/shared/google_icon.svg`} />
              <span>{copy}</span>
            </div>
            {this.isLinkedToGoogle() && linkedIcon}
          </div>
          {actionElement}
        </div>
        {unlinkCopy && <p className='unlink-copy'>{unlinkCopy}</p>}
      </React.Fragment>
    );
  }

  renderModal = () => {
    const { showGoogleModal, showCleverModal, showClasslinkModal } = this.state
    const { updateUser, email, timesSubmitted, errors, onUserUpdateSuccess } = this.props
    if (showGoogleModal) {
      return (
        <UnlinkModal
          cancel={this.hideGoogleModal}
          email={email}
          errors={errors}
          provider='Google'
          timesSubmitted={timesSubmitted}
          updateUser={updateUser}
        />
      )
    } else if (showCleverModal) {
      return (
        <UnlinkModal
          cancel={this.hideCleverModal}
          email={email}
          errors={errors}
          provider='Clever'
          timesSubmitted={timesSubmitted}
          updateUser={updateUser}
        />
      )
    } else if (showClasslinkModal) {
      return (
        <UnlinkModal
          cancel={this.hideClasslinkModal}
          email={email}
          errors={errors}
          onUserUpdateSuccess={onUserUpdateSuccess}
          provider='ClassLink'
          timesSubmitted={timesSubmitted}
          updateUser={updateUser}
        />
      )
    }
  }

  render() {
    return (
      <section aria-labelledby="linkedAccountsTitle" className='user-linked-accounts user-account-section'>
        {this.renderModal()}
        <h1 id="linkedAccountsTitle">Linked Accounts</h1>
        <div className="integration-links-container">
          {this.renderGoogleSection()}
          <div className='divider-line' />
          {this.renderCleverSection()}
          <div className='divider-line' />
          {this.renderClasslinkSection()}
          {this.renderNycpsSection()}
        </div>
      </section>
    )
  }
}
